;(function() {
    var
    
    _$wrapper = null,

    _report_id = null,

    //the popup showing the section headers
    _$popup = null,

    //our json data for the section headers
    _data = null,

    //set to true when a popup is open, can't open another
    _popup_open = false,
    

    //
    // init 
    //
    init = function() {
        _$wrapper = $('.layout-report');

        if (_$wrapper.length > 0) {
            //get the report id
            _report_id = _$wrapper.find('#hdnReportID').val();

            setupSectionHeadersLink();
            setupCellClick();
            setupCloseControlsClick();
            setupNewRowClick();
            setupDeleteRow();
        }
    },


    //
    // setup the columns link to show the popup
    //
    setupSectionHeadersLink = function() {
        _$wrapper.on('click', '#section-headers-edit', function () {
            if (!_popup_open) {
                _popup_open = true;
                //get the json
                delta.ajax.get(
                    '/report/sectionHeaders?reportID=' + _report_id,
                    function (json) {
                        //save the json
                        _data = json;

                        //open the popup
                        delta.popup.open({
                            type: 'confirm',
                            title: 'Column Section Headings',
                            content: '',
                            okButtonText: 'Save',
                            css: 'popup-section-headings-edit',
                            afterOpen: function($popup) {
                                _popup_open = false;

                                //save the popup
                                _$popup = $popup;

                                //render the table body
                                renderTable();

                                //setup the drag/drop for the table rows
                                setupDragDrop();
                            },
                            okCallback: function ($popup) {
                                rebuildSectionHeadingsJson();

                                if (validateData()) {
                                    $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                    //save it
                                    delta.ajax.post('/report/sectionheaders',
                                        _data,
                                        function (res) {
                                            if (res.ok) {
                                                window.location.reload();
                                                delta.popup.close($popup);
                                            }
                                            else {
                                                $popup.find('.modal-footer button').attr('disabled', false);
                                                $popup.find('.modal-footer i.fa-spinner').remove();
                                                alert(res.msg);
                                            }
                                        }
                                    );
                                } else {
                                    setTimeout(function() {
                                        delta.popup.enableButtons($popup);
                                        $popup.find('.modal-footer i.fa-spinner').remove();
                                    }, 1);
                                }

                                return false;
                            }
                        });
                    }
                );
            }

            return false;
        });
    },

        //
        // render the table
        //
        renderTable = function () {
            let s = '';

            //need to remove min-height, it's default to 85vh from some other css.
            s += '<div class="sortable" style="min-height:auto !important">';

            if (_data.sectionHeadings != null) {
                for (let i = 0; i < _data.sectionHeadings.length; i++) {
                    var m = _data.sectionHeadings[i];
                    s += `<div class="section-item draggable clearfix" data-index="${i}"><table><tbody>`;

                    let headingInputLabel = '<label class="form-label mb-0">Section Heading</label>';
                    let headingInput = `<input class="form-control" type="text" value="${m.heading ?? ""}" />`;

                    let colInputLabel = '<label class="form-label mb-0">Columns</label>';
                    let colInput = `<input class="form-control text-center" type="text" min="1" max="50" required value="${m.columnCount ?? 0}" />`;

                    // section header row
                    s += '<tr>';
                    s += '<td style=width:10%><div class="icon handle float-start" > <a href="#" class="handle"><i class="fa-regular fa-grip-dots-vertical fa-lg" style="color:gray"></i></a> </div></td>';
                    s += `<td data-prop="heading" style="width:63%">${headingInputLabel}${headingInput}</td>`;
                    s += `<td data-prop="columnCount" style="width:17%;padding-left:5px">${colInputLabel}${colInput}</td>`;
                    s += '<td style=width:10%><div class="icon float-end"><a class="lnk-delete-heading" href="#"><i class="fa-regular fa-trash-can fa-lg" style="color:gray"></i></a></div></td>';
                    s += '</tr></tbody></table></div>';
                }
            }

            //closes sortable
            s += '</div>';

            //add + row
            s += '<div class="plus">';
            s += '<a href="#" class="lnk-new-heading"><i class="fa-regular fa-circle-plus fa-lg" style="color:gray"></i></a>';
            s += '</div>';

            _$popup.find('.modal-body').html(s);
        },

        //
        // setup the drag/drop for the table rows
        //
        setupDragDrop = function () {
            _$popup.find('.modal-body .sortable').sortable({
                handle: '.handle',
                // axis: 'y',
                start: function () {},
                stop: function () {
                    rebuildSectionHeadingsJson();
                    setupDragDrop();
                }
            });

        },

        //
        // rebuild the _data.sectionHeadings based on the current table order 
        //(used before new colums or after drag / drop)
        //
        rebuildSectionHeadingsJson = function () {
            const rxNonNbr = /[^0-9]/;
            let idx = 0;
            let ar = [];

            _data.sectionHeadings = Array.from(document.querySelectorAll('.modal-body .section-item')).map((e, i) => {
                e.dataset.index = i;

                let tr = e.querySelector('tr:first-child'),
                    inpHead = tr.querySelector('td[data-prop="heading"] input'),
                    inpCols = tr.querySelector('td[data-prop="columnCount"] input');

                return {
                    heading: inpHead.value,
                    columnCount: rxNonNbr.test(inpCols.value) ?
                        parseInt(inpCols.value.split(rxNonNbr).find((e) => !isNaN(parseFloat(e)) && isFinite(e))) :
                        parseInt(inpCols.value)
                };
            });

            //rewrite table
            renderTable();
        },

        //
        // validate that section headings don't span more columns than the report has
        //
        validateData = function() {
            if (_data.sectionHeadings == null || _data.sectionHeadings.length == 0) {
                return true;
            } else {
                //get the span count for the headers.
                var cnt = 0;

                //get the column count
                for (var i = 0; i < _data.sectionHeadings.length; i++) {
                    cnt += _data.sectionHeadings[i].columnCount;
                }

                //if section headings column span > report column count, we're invalid
                if (cnt > _data.columnCount) {
                    delta.popup.open({
                        type: 'alert',
                        title: 'Section Headings',
                        content: 'Section headings can not span more than ' + _data.columnCount + ' column' + (_data.columnCount == 1 ? '' : 's') + '.',
                        css: 'modal-sm'
                    });

                    return false;
                } else {
                    return true;
                }
            }
        },


        //
        // New Row (+ on last row in table)
        //
        setupNewRowClick = function () {
            $(document).on('click', '.lnk-new-heading', function () {

                // get any edited headings
                rebuildSectionHeadingsJson();

                //create the new json object
                var m = new Object();

                m.heading = null;
                m.columnCount = 1;

                _data.sectionHeadings.push(m);

                //re-render the table
                renderTable();

                //click on the heading td of the new row to set focus
                var $divItem = _$popup.find('.modal-body .section-item:last');

                $divItem.find('td').eq(1).click();

                setupDragDrop();

                return false;
            });
        },

        //
        // Delete row
        //
        setupDeleteRow = function () {
            $(document).on('click', '.lnk-delete-heading', function () {

                // get any edited headings
                rebuildSectionHeadingsJson();

                // get the index
                var idx = $(this).closest('.section-item').attr('data-index');

                
                _data.sectionHeadings.splice(idx, 1);

                //re-render the table
                renderTable();

                setupDragDrop();

                return false;
            });
        },

    dummy = function(){};

    $(document).ready(init);
})();



